<script>
export default {
    name: "VBtnMenuItem",
    functional: true,
}
</script>

<template functional>
    <v-list-item
        v-bind="data.attrs"
        v-on="data.on"
        :class="[data.class, data.staticClass]"
    >
        <v-list-item-title><slot></slot></v-list-item-title>
    </v-list-item>
</template>

<style scoped lang="scss">

</style>
